import { GetStaticProps } from 'next'

import initApollo, { API } from '../../api'

import { TUTORIALS } from './queries'

export type Props = { posts: NonNullable<API.Tutorials['libraryPosts']>['nodes'] }

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Tutorials, API.TutorialsVariables>({
    query: TUTORIALS,
    variables: {
      perPage: 100000,
    },
  })

  return {
    props: {
      posts: data.libraryPosts?.nodes || [],
    },
  }
}
